import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import { testimonials, usageCards } from '../data/content';

/**
 * Sekcja opinii.
 * Dopóki w data/content.ts nie ma zweryfikowanych, autoryzowanych opinii,
 * pokazujemy zastosowania materiałów — bez fikcyjnych cytatów, nazwisk i ocen.
 */
export function Testimonials() {
  const hasVerified = testimonials.length > 0;
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-298" data-mp="36zqyv1yy5fxv">
      <div className="mx-auto max-w-5xl" data-id="element-299" data-mp="32060otrlpbm7">
        <h2 className="mx-auto max-w-2xl text-center font-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-300" data-mp="31z3citlnxn9z">
          {hasVerified ? 'Co mówią nauczyciele chemii' : 'Jak nauczyciele mogą wykorzystać Wizualną Chemię™'}
        </h2>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-3" data-id="element-301" data-mp="v9gb9qm8i8qq">
          {hasVerified ? testimonials.map((t, i) => <motion.article key={`${t.name}-${t.city}`} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-chem/20 bg-white p-6 shadow-sm shadow-chem/5" data-id="element-302" data-mp="qaljhz6ah9uh" data-mpi={i}>
                  {t.verified && <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-chem/10 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.1em] text-chem-deep" data-id="element-303" data-mp="c8y3e5zogedk">
                      <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-304" data-mp="14uzh41xjco8w" />
                      Zweryfikowana opinia
                    </span>}

                  {t.verified && typeof t.rating === 'number' && <div className="mt-3 flex gap-0.5" aria-label={`Ocena ${t.rating} na 5`} data-id="element-305" data-mp="v44u2vcgtkme">
                      {Array.from({
              length: t.rating
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-chem text-chem" aria-hidden="true" data-id="element-306" data-mp="1nmacavaann6l" data-mpi={s} />)}
                    </div>}

                  <p className="mt-4 flex-1 text-sm leading-relaxed text-ink/80" data-id="element-307" data-mp="1xhh841b51lob">„{t.quote}”</p>

                  <div className="mt-auto pt-6" data-id="element-308" data-mp="1sjflx7if168m">
                    <p className="text-sm font-bold text-ink" data-id="element-309" data-mp="1oh2iwqv1zmfj">{t.name}</p>
                    <p className="text-xs text-ink/60" data-id="element-310" data-mp="1oj5h3y6d0lvc">{t.city}, Polska</p>
                    <p className="text-xs italic text-chem-deep" data-id="element-311" data-mp="1jhpz6ezhavh6">{t.role}</p>
                  </div>
                </motion.article>) : usageCards.map((card, i) => <motion.article key={card.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-chem/20 bg-white p-6 shadow-sm shadow-chem/5" data-id="element-312" data-mp="19sogui5go201" data-mpi={i}>
                  <span className="font-display text-sm font-bold uppercase tracking-[0.14em] text-chem" data-id="element-313" data-mp="qu2fd26188vl">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <h3 className="mt-3 font-display text-xl font-bold text-ink" data-id="element-314" data-mp="37epap9fjn8d8">{card.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/70" data-id="element-315" data-mp="3cg4uky5zj8u1">
                    {card.description}
                  </p>
                </motion.article>)}
        </div>
      </div>
    </section>;
}